import { instance } from "libs/api";

import { ContentVideoListItem } from "../../content.types";
import { ApiRoutesContent } from "./../../constants";
import { CreateVideoRequestBody } from "./createVideo.types";

export const requestCreateVideo = async (
  body: CreateVideoRequestBody
): Promise<ContentVideoListItem> => {
  return await instance.post(ApiRoutesContent.Video, body);
};
